import { RegionalStoreStructureDet } from './RegionalStoreStructureDet';

export class RegionalStoreStructure{
    regStoreStrId: number;
    name: string;
    storeCount: number;
    StoreCountOrganization: number;
    catDetRegionStoreTypeId: number;
    regStoreStrParentId: number;
    detail: RegionalStoreStructureDet[];
}